
import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../services/api';
import './EcoPersonaQuiz.css';
import shrokone from './shrok1.png';
import shroktwo from './shrok2.png';
import shrokthree from './shrok3.png';
import shrokfour from './shrok4.png';
import shrokfive from './shrok5.png';
import shroksix from './shrok6.png';
import { Helmet } from 'react-helmet';


const EcoPersonaQuiz = () => {

    // Quiz state
    const [answers, setAnswers] = useState({});
    const [quizComplete, setQuizComplete] = useState(false);
    const [showResults, setShowResults] = useState(false);
    const [result, setResult] = useState(null);

    // Auth state
    const [showAuthForm, setShowAuthForm] = useState(false);
    const [isLogin, setIsLogin] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [email, setEmail] = useState('');
    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [loggedIn, setLoggedIn] = useState(false);
    const [userEmail, setUserEmail] = useState('');

    // Products state
    const [recommendedProducts, setRecommendedProducts] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(false);

    const getShrokImage = (resultId) => {
        const shrokImages = {
            1: shrokone,
            2: shroktwo,
            3: shrokthree,
            4: shrokfour,
            5: shrokfive,
            6: shroksix
        };
        return shrokImages[resultId];
    };

    const downloadShrokPoster = (resultId, resultTitle) => {
        const shrokImage = getShrokImage(resultId);
        const link = document.createElement('a');
        link.href = shrokImage;
        link.download = `${resultTitle.replace(/[^a-zA-Z0-9]/g, '_')}_Shrok_Poster.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Quiz Questions
    // QUIZ QUESTIONS HERE (Same as original code)
    const questions = [
        {
            question: "How long do you usually keep a product before replacing it?",
            options: [
                { text: "I cycle it out after a few uses.", value: "what-is-compost" },
                { text: "I use it until it is unusable, then throw it away.", value: "poop" },
                { text: "Use it for some time, but while its still usable, I donate it.", value: "food-waste" },
                { text: "I'm a one time use kind of person.", value: "plant-stuff" },
                { text: "Until its basically disintegrated.", value: "leaf" }
            ]
        },

        {
            question: "How do you usually shop for clothes?",
            options: [
                { text: "Whatever's cheapest and fastest", value: "cheap-fast" },
                { text: "I thrift when I can, but I also panic buy online", value: "thrift-panic" },
                { text: "I save up for quality basics I'll wear forever", value: "quality-basics" },
                { text: "I steal my sibling's closet. It's basically reuse, right?", value: "sibling-closet" },
                { text: "Plant-based stuff.", value: "leaf" },
            ]
        },
        {
            question: "What's in your soap lineup?",
            options: [
                { text: "One bottle for body, face, and possibly dishes", value: "one-bottle" },
                { text: "Something unscented and organic-ish", value: "unscented-organic" },
                { text: "Whatever's cruelty-free and smells like eucalyptus", value: "cruelty-free" },
                { text: "My DIY bar soap that kinda crumbles but I'm committed", value: "diy-soap" },
                { text: "I just realized my shampoo has parabens and could be bad for me", value: "parabens" },
            ]
        },
        {
            question: "How do you feel about cleaning?",
            options: [
                { text: "Honestly? I avoid it until guests are coming", value: "avoid-cleaning" },
                { text: "I like when it's done but not the process", value: "like-when-done" },
                { text: "I put on music and go full minimalist Pinterest mood", value: "pinterest-mood" },
                { text: "It's a form of self-care tbh", value: "cleaning-self-care" },
                { text: "I LOVE IT", value: "leaf" }
            ]
        },
        {
            question: "You're handed a blank notebook. What do you do?",
            options: [
                { text: "Doodle for 5 minutes and forget about it", value: "doodle-forget" },
                { text: "Make a weekly goal list with checkboxes", value: "goal-list" },
                { text: "Turn it into a gratitude or habit tracker", value: "habit-tracker" },
                { text: "Stick stickers all over it immediately", value: "stickers" },
                { text: "Panic — too much pressure to ruin the aesthetic", value: "panic-aesthetic" },
            ]
        },
        {
            question: "Your approach to sustainable shopping is…",
            options: [
                { text: "I try, but I get overwhelmed fast", value: "overwhelmed" },
                { text: "I love finding brands doing it right", value: "right-brands" },
                { text: "Honestly, it's complicated — I care, but life is expensive", value: "complicated" },
                { text: "I've made small swaps and that feels good", value: "small-swaps" },
                { text: "I want to do better, but I need things that work for real", value: "need-works" },
                { text: "Hemp Products. Duh.", value: "leaf" }
            ]
        },
        {
            question: "You're handed a metal straw. What's your reaction?",
            options: [
                { text: "My time has come.", value: "time-has-come" },
                { text: "Cool, but I still forget mine every time", value: "forget-straw" },
                { text: "I only drink iced lattes — perfect", value: "iced-lattes" },
                { text: "I prefer a compostable cup made of seaweed, but okay", value: "compostable-cup" },
                { text: "I already have a metal straw on me.", value: "leaf" }
            ]
        },
        {
            question: "What's your go-to footwear vibe?",
            options: [
                { text: "Slides or sandals I've had for 5 years", value: "old-sandals" },
                { text: "Sneakers for sure", value: "sneakers" },
                { text: "Shoes with cool designs", value: "cool-designs" },
                { text: "Crocs. I don't care what anyone says", value: "crocs" },
                { text: "I dont wear shoes", value: "no-shoes" },
                { text: "Anything Green.", value: "leaf" }
            ]
        },
        {
            question: "What do you look for in skincare or cosmetics?",
            options: [
                { text: "Something gentle and simple", value: "gentle-simple" },
                { text: "Natural ingredients but still cute packaging", value: "natural-cute" },
                { text: "Cruelty-free or I'm out", value: "cruelty-free-skincare" },
                { text: "I DIY everything with shea butter and vibes", value: "diy-skincare" },
                { text: "Whatever's cheap and doesn't burn", value: "cheap-skincare" },
                { text: "Natural herbs.", value: "leaf" }
            ]
        },
        {
            question: "Fun Question: Which unexpected animal are you aligned with?",
            options: [
                { text: "Pigeon — misunderstood but thriving", value: "pigeon" },
                { text: "Capybara — chill and oddly magnetic", value: "capybara" },
                { text: "Earthworm — humble, grounded, essential", value: "earthworm" },
                { text: "Crow — intelligent, collects shiny things", value: "crow" },
                { text: "Frog — doing your best", value: "frog" },
                { text: "Leaves. They are animals IMO.", value: "leaf" }
            ]
        }

        // ... rest of the questions remain the same
    ];

    // Results data
    const results = [
        {
            id: 1,
            title: "🌿 The Soft Start Sustainability Seeker",
            description: "You're curious, a little overwhelmed, and maybe still Googling what compost actually is — but you care. You're not trying to be perfect, you're just trying to be better. You've made a few swaps (reusable tote? check. metal straw? somewhere in that drawer…), and you're looking for products that are affordable, accessible, and make you feel like you're doing your part without flipping your whole lifestyle. We recommend products that are closer to your vibe already.",
            products: [
                ""
            ],
            // toner, notebook, toothbrush, tshirt, shoe, necklace
            // done
            productIds: [419, 1710, 464, 1748, 1939, 415],
            matchingAnswers: ["what-is-compost", "cheap-fast", "one-bottle", "overwhelmed", "forget-straw", "old-sandals", "cheap-skincare", "panic-aesthetic"]
        },
        // ... rest of the results remain the same with added productIds arrays
        {
            id: 2,
            title: "🪴 The DIY-ish Earth Guardian",
            description: "You know what a loofah plant is and you've considered growing one. You're composting (or want to), you like ingredients you can pronounce, and you've probably attempted to make your own cleaner at some point. You're not crunchy — you're intentional. Sustainability for you is both practical and a personal ritual. You often shop with it in mind!",
            products: [
                ""
            ],
            //done
            // Soap, Skincare, seed paper stationary, cleaning brush, shirt
            // FIX THIS ONE
            productIds: [1735, 1707, 242, 2401, 2442, 397],
            matchingAnswers: ["plant-stuff", "quality-basics", "diy-soap", "small-swaps", "compostable-cup", "cool-designs", "diy-skincare", "earthworm"]
        },
        {
            id: 3,
            title: "✨ The Conscious Maximalist",
            description: "You love a bold tote bag and an even bolder mission statement. You're into sustainability, but you also love style and joy and self-expression. You'll pay extra for ethical, vegan, cruelty-free — and aesthetic. You're living proof that doing good doesn't have to mean looking boring. You love showcasing new items and making a statement with your purchases.",
            products: [
                ""
            ],
            //done
            // tote, hair accessory, highlighter, shoe, jewelry, compost bags
            // FIX THIS ONE
            productIds: [1716, 2682, 418, 1938, 1721, 432],
            matchingAnswers: ["food-waste", "thrift-panic", "cruelty-free", "right-brands", "iced-lattes", "cool-designs", "cruelty-free-skincare", "crow"]
        },
        {
            id: 4,
            title: "🐸 The Chill Eco Champion",
            description: "You're low-key but locked in. You thrift often, you know your way around ingredients lists, and you don't mind a little eco-chaos (yes, your shampoo bar is crumbling, but it's fine). You care deeply about impact but aren't preachy — your lifestyle is a quiet protest against fast everything.",
            products: [
                ""
                //ecofriendly sponge, deodorant, planner, shoes, shirt, joggers
                // done
            ],
            productIds: [1712, 420, 457, 2633, 2618, 1789],
            matchingAnswers: ["poop", "sibling-closet", "unscented-organic", "cleaning-self-care", "need-works", "no-shoes", "natural-cute", "capybara"]
        },
        {
            id: 5,
            title: "🌍 The Ethical Overachiever (But Make It Kind)",
            description: "You're the friend who always knows which brand is B Corp certified. You research everything, you've probably gone through a coconut oil phase, and you're the go-to person for eco advice. You take sustainability seriously — but you also love helping others feel welcome to start.",
            products: [
                ""
            ],
            // toilet paper, ecofriendly lip balm, tee, lotion, 
            // FIX
            productIds: [2524, 2561, 1751, 2621, 2556, 394],
            matchingAnswers: ["plant-stuff", "quality-basics", "gentle-simple", "small-swaps", "time-has-come", "sneakers", "cruelty-free-skincare", "goal-list", "crow", "frog"]
        },
        {
            id: 6,
            title: "🍃 Hempalicious",
            description: "You're all about that hemp life! Sustainable, versatile, and with a touch of counterculture cool. You appreciate hemp's many uses - from clothing to accessories - and its minimal environmental impact. Your eco-conscious choices extend beyond trends into a genuine lifestyle commitment.",
            products: [
                ""
            ],
            // FIX
            productIds: [1791, 2516, 2497, 2630, 2499, 1713],
            matchingAnswers: ["leaf"]
        }
    ];


    const sustainabilitySteps = {
        1: { // Soft Start Sustainability Seeker
            steps: [
                "Start with one simple swap from your personalized products below",
                "Send this quiz to friends who are also curious about sustainability",
                "Follow our Instagram for bite-sized eco tips and inspiration"
            ]
        },
        2: { // DIY-ish Earth Guardian
            steps: [
                "Try one DIY-friendly product from Verdure (like our masks or soaps)",
                "Subscribe to our newsletter for seasonal sustainability challenges and tutorials",
                "Share your creations using sustainable ingredients with our community"
            ]
        },
        3: { // Conscious Maximalist
            steps: [
                "Curate your sustainable aesthetic by exploring Verdure's trending collections",
                "Follow our Instagram for curated posts on sustainable style inspiration",
                "Send this quiz to friends and compare your eco personas together"
            ]
        },
        4: { // Chill Eco Champion
            steps: [
                "Browse Verdure for low-key sustainable swaps that fit your lifestyle",
                "Subscribe to our newsletter for effortless eco tips delivered monthly",
                "Challenge friends to take this quiz and see their eco personalities"
            ]
        },
        5: { // Ethical Overachiever
            steps: [
                "Explore Verdure's impact-focused brands and certifications",
                "Subscribe to our newsletter to stay updated on the latest in ethical consumption",
                "Share this quiz with your network to help others discover their eco potential"
            ]
        },
        6: { // Hempalicious
            steps: [
                "Dive deep into Verdure's hemp and sustainable fiber collections",
                "Follow our Instagram for posts about innovative sustainable materials",
                "Send this quiz to fellow sustainability enthusiasts and compare results"
            ]
        }
    };

    // Handle question answering - updated to set answer without changing question
    const handleAnswer = (questionIndex, answerValue) => {
        const updatedAnswers = { ...answers, [questionIndex]: answerValue };
        setAnswers(updatedAnswers);
    };

    // Determine user's result based on their answers
    const calculateResult = () => {
        // Count matches with each persona
        const answerValues = Object.values(answers);
        const matchCounts = results.map(result => {
            const matchCount = answerValues.filter(answer =>
                result.matchingAnswers.includes(answer)
            ).length;
            return { id: result.id, count: matchCount };
        });

        // Find the result with the most matches
        const maxMatches = Math.max(...matchCounts.map(m => m.count));
        const bestMatch = matchCounts.find(m => m.count === maxMatches);

        // If there's a leaf emoji anywhere, it's Hempalicious
        if (answerValues.includes('leaf')) {
            return results.find(r => r.id === 6);
        }

        return results.find(r => r.id === bestMatch.id);
    };

    // Handle revealing results (shows auth form first)
    const handleShowResults = () => {
        if (Object.keys(answers).length === 0) {
            setError('Please answer at least one question before getting your results.');
            return;
        }

        setQuizComplete(true);
        setShowAuthForm(true);

        // Pre-calculate the result
        const userResult = calculateResult();
        setResult(userResult);

        // Pre-fetch products
        fetchRecommendedProducts(userResult.productIds);
    };

    // Fetch recommended products based on persona result
    const fetchRecommendedProducts = async (productIds) => {
        setLoadingProducts(true);

        try {
            const productPromises = productIds.map(id =>
                axios.get(`${API_URL}api/products/${id}/`)
            );

            const productResponses = await Promise.allSettled(productPromises);

            const successfulProducts = productResponses
                .filter(response => response.status === 'fulfilled')
                .map(response => response.value.data);

            setRecommendedProducts(successfulProducts);
        } catch (error) {
            console.error('Error fetching recommended products:', error);
        } finally {
            setLoadingProducts(false);
        }
    };

    // Send email with results to user
    // const sendResultsEmail = async (userEmail, userResult) => {
    //     try {
    //         await axios.post(`${API_URL}api/send-results-email/`, {
    //             email: userEmail,  // Add the email from fetchUserEmail
    //             result: {
    //                 title: userResult.title,
    //                 description: userResult.description,
    //                 products: userResult.products
    //             }
    //         });
    //         console.log('Results email sent successfully');
    //     } catch (error) {
    //         console.error('Error sending results email:', error);
    //     }
    // };

    const sendResultsEmail = async (userEmail, userResult, recommendedProducts) => {
        try {
            await axios.post(`${API_URL}api/send-results-email/`, {
                email: userEmail,
                result: {
                    title: userResult.title,
                    description: userResult.description,
                    products: userResult.products
                },
                // Include product details for creating hyperlinks
                productDetails: recommendedProducts.map(product => ({
                    id: product.id,
                    name: product.name,
                    image: product.images && product.images[0] ? product.images[0].image : null
                }))
            });
            console.log('Results email sent successfully');
        } catch (error) {
            console.error('Error sending results email:', error);
        }
    };


    // Get user email after login
    const fetchUserEmail = async () => {
        try {
            const { data } = await axios.get(`${API_URL}update-email/`);
            setUserEmail(data.email);
            console.log(data.email);
            return data.email;

        } catch (error) {
            console.error('Error fetching user email:', error);
            return null;
        }
    };

    // Handle skipping login/register
    const handleSkip = () => {
        setShowAuthForm(false);
        setShowResults(true);
    };

    // Handle login form submission
    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const { data } = await axios.post(
                `${API_URL}token/`,
                { username, password },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                },
                { withCredentials: true }
            );

            localStorage.setItem("access_token", data.access);
            localStorage.setItem("refresh_token", data.refresh);
            axios.defaults.headers.common["Authorization"] = `Bearer ${data["access"]}`;

            setLoggedIn(true);
            setMessage('Successfully logged in!');

            // Get user email and send results
            // const email = await fetchUserEmail();
            // if (email && result) {
            //     sendResultsEmail(email, result);
            // }

            const email = await fetchUserEmail();
            if (email && result) {
                sendResultsEmail(email, result, recommendedProducts);
            }

            // Show results after successful login
            setTimeout(() => {
                setShowResults(true);
                setShowAuthForm(false);
            }, 1500);

        } catch (err) {
            setError('Login failed. Please check your credentials.');
            setLoading(false);
        }
    };

    // Handle register form submission
    const handleRegister = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');

        if (password !== password2) {
            setError('Passwords do not match!');
            setLoading(false);
            return;
        }

        try {
            await axios.post(`${API_URL}register/`, {
                fname,
                lname,
                username,
                password1: password,
                password2,
                email,
            });

            setMessage('Registration successful! Logging you in...');

            // Login after successful registration
            try {
                const { data } = await axios.post(
                    `${API_URL}token/`,
                    { username, password },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    },
                    { withCredentials: true }
                );

                localStorage.setItem("access_token", data.access);
                localStorage.setItem("refresh_token", data.refresh);
                axios.defaults.headers.common["Authorization"] = `Bearer ${data["access"]}`;

                setLoggedIn(true);

                // Get user email and send results
                // const email = await fetchUserEmail();
                // if (email && result) {
                //     sendResultsEmail(email, result);
                // }
                const email = await fetchUserEmail();
                if (email && result) {
                    sendResultsEmail(email, result, recommendedProducts);
                }

                // Show results after successful login
                setTimeout(() => {
                    setShowResults(true);
                    setShowAuthForm(false);
                }, 1500);

            } catch (loginErr) {
                setError('Registration was successful but login failed. Please try logging in manually.');
                setLoading(false);
            }

        } catch (err) {
            setError('Registration failed. Please try again.');
            setLoading(false);
        }
    };

    return (


        <div className="eco-quiz-container">

<Helmet>
  <title>Sustainable Shopping Quiz | Verdure</title>
  <meta name="description" content="Not sure where to start? Take our quick quiz to find sustainable brands that match your values and style." />
  <meta property="og:title" content="Sustainable Shopping Quiz | Verdure" />
  <meta property="og:description" content="Get personalized brand and product recommendations that match your values and lifestyle." />
</Helmet>

            <div className="quiz-header">
                <h1>Find Your Shopping Persona.</h1>
                <p>Are you already a sustainable overachiever? Learn what Verdure mascot you are and your eco-shopping habits.</p>
            </div>

            {!quizComplete && (
                <>
                    {/* Questions */}
                    <div>
                        {questions.map((q, qIndex) => (
                            <div key={qIndex} className="question-container">
                                <div className="question-title">
                                    <span className="question-number">{qIndex + 1}</span>
                                    {q.question}
                                </div>

                                <div className="options-grid">
                                    {q.options.map((option, oIndex) => (
                                        <button
                                            key={oIndex}
                                            className={`option-button ${answers[qIndex] === option.value ? 'option-selected' : ''}`}
                                            onClick={() => handleAnswer(qIndex, option.value)}
                                        >
                                            {option.text}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Get Results Button */}
                    <div className="results-button-container">
                        {error && <p className="error-message">{error}</p>}
                        <button
                            className="get-results-button"
                            onClick={handleShowResults}
                        >
                            Get My Results
                        </button>
                    </div>
                </>
            )}

            {/* Email Notification Section */}
            <div className="skip-section">
                <p className="skip-text">We will send the results right to your email!</p>
            </div>

            {/* Authentication Form */}
            {showAuthForm && (
                <div className="auth-form-container">
                    <h2 className="auth-form-header">
                        {loggedIn ? 'You\'re logged in!' : (isLogin ? 'Login to save your results' : 'Create an account to view results')}
                    </h2>

                    {loading && (
                        <div className="spinner-container">
                            <div className="spinner"></div>
                        </div>
                    )}

                    {message && <p className="success-message">{message}</p>}
                    {error && <p className="error-message">{error}</p>}

                    {!loggedIn && (
                        <>
                            {isLogin ? (
                                // Login Form
                                <form onSubmit={handleLogin}>
                                    <div className="form-group">
                                        <label className="form-label">Username</label>
                                        <input
                                            type="text"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            className="form-input"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Password</label>
                                        <input
                                            type="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            className="form-input"
                                            required
                                        />
                                    </div>
                                    <div className="form-actions">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="auth-button"
                                        >
                                            Log In
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => setIsLogin(false)}
                                            className="auth-link"
                                        >
                                            Need an account?
                                        </button>
                                    </div>
                                </form>
                            ) : (
                                // Register Form
                                <form onSubmit={handleRegister}>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">First Name</label>
                                            <input
                                                type="text"
                                                value={fname}
                                                onChange={(e) => setFname(e.target.value)}
                                                className="form-input"
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Last Name</label>
                                            <input
                                                type="text"
                                                value={lname}
                                                onChange={(e) => setLname(e.target.value)}
                                                className="form-input"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Email</label>
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="form-input"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Username</label>
                                        <input
                                            type="text"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            className="form-input"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Password</label>
                                        <input
                                            type="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            className="form-input"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Confirm Password</label>
                                        <input
                                            type="password"
                                            value={password2}
                                            onChange={(e) => setPassword2(e.target.value)}
                                            className="form-input"
                                            required
                                        />
                                    </div>
                                    <div className="form-actions">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="auth-button"
                                        >
                                            Register
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => setIsLogin(true)}
                                            className="auth-link"
                                        >
                                            Already have an account?
                                        </button>
                                    </div>
                                </form>
                            )}

                            <div className="skip-section">
                                <p className="skip-text">Don't want to create an account yet?</p>
                                <button
                                    onClick={handleSkip}
                                    className="skip-button"
                                >
                                    Skip and see results
                                </button>
                                <p className="skip-note">
                                    (Note: You'll need an account to purchase recommended products)
                                </p>
                            </div>
                        </>
                    )}
                </div>
            )}

            {/* Results Section */}
            {showResults && result && (
                <div className="results-container">
                    {/* <div className="results-header">
                        <h2 className="results-title">{result.title}</h2>
                        <p className="results-description">{result.description}</p>
                    </div> */}

                    <div className="results-header">
                        <div className="results-content">
                            <div className="results-text">
                                <h2 className="results-title">{result.title}</h2>
                                <p className="results-description">{result.description}</p>

                                <div className="sustainability-steps">
                                    <h3 className="steps-title">Your Next Steps:</h3>
                                    <ul className="steps-list">
                                        {sustainabilitySteps[result.id].steps.map((step, index) => (
                                            <li key={index} className="step-item">
                                                <span className="step-number">{index + 1}</span>
                                                {step}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="shrok-poster-container">
                                <img
                                    src={getShrokImage(result.id)}
                                    alt={`${result.title} Shrok Poster`}
                                    className="shrok-poster-image"
                                />
                                <button
                                    className="download-shrok-button"
                                    onClick={() => downloadShrokPoster(result.id, result.title)}
                                >
                                    Download Your Shrok
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* <h3 className="product-recommendations-title">Your Recommended Products:</h3>
                    <ul className="product-recommendations-list">
                        {result.products.map((product, index) => (
                            <li key={index}>{product}</li>
                        ))}
                    </ul> */}

                    {/* Product Grid */}
                    <div className="product-section">
                        <h3 className="product-section-title">Your Personalized Products:</h3>

                        {loadingProducts ? (
                            <div className="products-loading">
                                <div className="spinner"></div>
                            </div>
                        ) : recommendedProducts.length > 0 ? (
                            <div className="product-grid">
                                {recommendedProducts.map((product) => (
                                    <div key={product.id} className="product-card">
                                        <a href={`https://urverdure.app/shop/products/${product.id}`} target="_blank" rel="noopener noreferrer">
                                            {product.images && product.images[0] && (
                                                <img
                                                    src={product.images[0].image}
                                                    alt={product.name}
                                                    className="product-image"
                                                />
                                            )}
                                            <div className="product-details">
                                                <h4 className="product-name">{product.name}</h4>
                                                <p className="product-price">${product.price}</p>
                                                {/* <p className="product-description">{product.description}</p> */}
                                                <button className="product-button">
                                                    View Details
                                                </button>
                                            </div>
                                        </a>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="no-products-message">No products available at the moment.</p>
                        )}
                    </div>

                    <div className="shop-all-button-container">
                        <button
                            className="shop-all-button"
                            onClick={() => window.open("/shop", "_blank", "noopener,noreferrer")}
                        >
                            Shop All Products
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EcoPersonaQuiz;